const apiKey = process.env.NEXT_PUBLIC_API_KEY!;

type Params = {
  publicBaseUrl: string;
  family: string;
};

/**
 * Overlay styles come from alltrails-carto (`styles/overlays/<family>/<family>.json`):
 * the monolith resolves the current releaseId and redirects `releases/latest` to the immutable CloudFront path for it.
 */
export const getOverlayStyleUrl = ({ publicBaseUrl, family }: Params) =>
  `${publicBaseUrl}/api/alltrails/cartography/releases/latest/styles/overlays/${family}/${family}.json?key=${apiKey}`;
